import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import { AuthProvider } from "./lib/auth";
import { Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { version } from "./lib/version";
import { useEffect } from "react";
import { CacheBuster } from "./CacheBuster";
import { LoginRoutes } from "./routes/loginRoutes";
import { CamapignRoutes } from "./routes/campaignRoutes";
import { SegmentRoutes } from "./routes/segmentRoutes";
import { AppLayout } from "./components/containers/appLayout/AppLayout";
import { NotFound } from "./pages/NotFound";
import { TermsOfService } from "./pages/TermsOfService";
import { DownloadJson } from "./pages/DownloadJson";
import { RequireAuthWrapper } from "./pages/RequireAuthWrapper";
import { LandingPage } from "./pages/landingPage";
import { HumanInTheLoopRoutes } from "./routes/humanInTheLoop";
import { AdminRoutes } from "./routes/adminRoutes";
import { PermissionsWrapper } from "./pages/PermissionsWrapper";
import {
  AccountsUserRoleChoices,
} from "./graphql/generated";
import { PublisherRoutes } from "./routes/publisherRoutes";

export const App = () => {
  useEffect(() => {
    console.log(`illumaland version ${version}`);
  });

  return (
    <HelmetProvider>
      <AuthProvider>
        <ChakraProvider theme={theme}>
          <CacheBuster />
          <Routes>
            <Route path={"/"}>
              <Route
                path={""}
                element={
                  <RequireAuthWrapper>
                    <AppLayout pageTitle={""}>
                      <LandingPage />
                    </AppLayout>
                  </RequireAuthWrapper>
                }
              />

              <Route path={"login/*"} element={<LoginRoutes />} />
              <Route path={"campaigns/*"} element={<CamapignRoutes />} />
              <Route
                path={"publisher/*"}
                element={
                  <PermissionsWrapper agencyPartnerCheck={true}>
                    <PublisherRoutes />
                  </PermissionsWrapper>
                }
              />
              <Route
                path={"segments/*"}
                element={
                  <PermissionsWrapper
                    agencyPartnerCheck={true}
                  >
                    <SegmentRoutes />
                  </PermissionsWrapper>
                }
              />
              <Route
                path={"human-in-the-loop/*"}
                element={
                  <PermissionsWrapper agencyPartnerCheck={true}>
                    <HumanInTheLoopRoutes />
                  </PermissionsWrapper>
                }
              />
              <Route
                path={"admin-dashboard/*"}
                element={
                  <PermissionsWrapper
                    mustBeStaff={true}
                    allowedRoles={[
                      AccountsUserRoleChoices.SeniorManagement,
                      AccountsUserRoleChoices.Tech,
                      AccountsUserRoleChoices.Sales,
                      AccountsUserRoleChoices.Data,
                    ]}
                  >
                    <AdminRoutes />
                  </PermissionsWrapper>
                }
              />

      
              <Route
                path={"404"}
                element={
                  <AppLayout pageTitle={"404 Not Found"}>
                    <NotFound />
                  </AppLayout>
                }
              />

              <Route
                path={"terms-of-service"}
                element={
                  <AppLayout pageTitle={"Illuma Technology Terms of Service"}>
                    <TermsOfService />
                  </AppLayout>
                }
              />

              <Route
                path={"download-json"}
                element={
                  <AppLayout pageTitle={""}>
                    <DownloadJson />
                  </AppLayout>
                }
              />

              <Route
                path={"*"}
                element={<Navigate to={"/404"} replace={true} />}
              />
            </Route>
          </Routes>
        </ChakraProvider>
      </AuthProvider>
    </HelmetProvider>
  );
};
